import { render, staticRenderFns } from "./ProgrammesView.vue?vue&type=template&id=7afeb496&scoped=true&"
import script from "./ProgrammesView.vue?vue&type=script&lang=js&"
export * from "./ProgrammesView.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammesView.vue?vue&type=style&index=0&id=7afeb496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afeb496",
  null
  
)

export default component.exports